// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__G0dAa","gfeWrapper":"CalendarEvent_gfeWrapper__-50BF"};